import { makeStyles } from '@material-ui/core/styles';

export const useUploadFilesStyles = makeStyles(() => ({
  container: {
    marginTop: 20,
    border: '1.5px dashed #464646',
    display: 'flex',
    cursor: 'pointer',
    marginBottom: 15,
  },
  icon: {
    width: (props) => (props.mobile ? 55 : 60),
    height: (props) => (props.mobile ? 45 : 50),
    margin: (props) => (props.mobile ? 8 : 15),
  },
  title: {
    marginTop: (props) => (props.mobile ? 10 : 15),
    fontSize: (props) => (props.mobile ? '15px' : '16px'),
    color: '#464646',
    fontWeight: 'bold',
  },
  subtitle: {
    fontSize: (props) => (props.mobile ? '13px' : '14px'),
    color: '#666666',
  },
  thumbsContainer: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    marginTop: 16,
  },
  thumb: {
    display: 'inline-flex',
    borderRadius: 2,
    border: '1px solid #EAEAEA',
    marginBottom: 8,
    marginRight: 15,
    width: (props) => (props.mobile ? 80 : 100),
    height: (props) => (props.mobile ? 80 : 100),
    padding: 4,
    boxSizing: 'border-box',
    position: 'relative',
  },
  thumbInner: {
    display: 'flex',
    minWidth: 0,
    overflow: 'hidden',
  },
  image: {
    display: 'block',
    width: 'auto',
    height: '100%',
  },
  iconImage: {
    position: 'absolute',
    top: -20,
    right: -25,
    color: '#FF4F4B',
  },
  rejectionsMessage: {
    color: '#FF4F4B',
    fontSize: (props) => (props.mobile ? 14 : 15),
  },
}));
